import React, { useContext, useMemo } from 'react';
import InputConfig from '../../../../../Components/InputConfig';
import SwitchInput from '../../../../../Components/SwitchInput';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import { toast } from 'react-toastify';
//mui imports====
import { Grid, Alert, Box, Typography, } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

// Utilities
import {
	isOptimizedTpvEnabled as checkOptimizedTpvEnabled,
	validateVastDaisyChainingForOptimizedTpv,
	canEnableOptimizedTpv,
} from '../../../../../utilities/optimizedTpvConfigCheck';

const OptimizedTpvConfig = ({ keyData }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const isOptimizedTpvEnabled = useMemo(() => {
		return checkOptimizedTpvEnabled(rawConfig);
	}, [rawConfig]);

	const vastDaisyChainingValidation = useMemo(() => {
		return validateVastDaisyChainingForOptimizedTpv(rawConfig);
	}, [rawConfig]);

	const handleEnabledToggle = (updateFn) => {
		return (updater) => {
			if (!isOptimizedTpvEnabled) {
				const validation = canEnableOptimizedTpv(rawConfig);

				if (!validation.canEnable) {
					const firstError = validation.errors[0];
					toast.error(firstError.message, {
						position: toast.POSITION.BOTTOM_RIGHT,
						autoClose: 6000
					});
					return;
				}
			}

			updateFn(updater);
		};
	};

	return (
		<Box sx={{ mt: 4, mb: 4, px: 3 }}>
			<Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
				Vast Broadcasting
			</Typography>

			<Box sx={{ width: '100%' }}>
				{/* Vast Daisy Chaining Status */}
				{isOptimizedTpvEnabled && !vastDaisyChainingValidation.isValid && (
					<Alert
						severity="warning"
						icon={<WarningAmberIcon />}
						sx={{ marginBottom: '1rem' }}
					>
						<Typography variant="body2" fontWeight={600}>
							⚠️ Configuration Issue: {vastDaisyChainingValidation.message}
						</Typography>
						<Typography variant="body2">
							At least one country (or DEFAULT) must be enabled and have VastTags configured in Vast Daisy Chaining for Optimized TPV to work.
						</Typography>
					</Alert>
				)}
				{/* Requirements Info Box */}
				<Alert
					severity="info"
					sx={{ marginBottom: '1rem' }}
				>
					<Typography variant="body2" fontWeight={600}>
						Requirements for Vast Broadcasting:
					</Typography>
					<Box component="ul" sx={{ margin: '0.5rem 0', paddingLeft: '1.5rem' }}>
						<li>
							<Typography variant="body2">
								Vast Daisy Chaining must have at least one country (or DEFAULT) enabled with VastTags configured.
							</Typography>
						</li>
					</Box>
				</Alert>
			</Box>

			<Grid container spacing={3} sx={{ mt: '2rem', pb: '2rem', border: '1px solid darkgrey', borderRadius: '7px', ml: '0.4rem', width: '50%' }} >
				<Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', mt: '1rem', pl: '0px', maxWidth: '20rem !important' }}>
					<SwitchInput
						label="Enabled"
						keyData={`${keyData}.optimizedTpvRequests.enabled`}
						object={rawConfig}
						updateObject={handleEnabledToggle(updateRawConfig)}
					/>
				</Grid>
				<Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', mt: '-1.5rem', minWidth: '60% !important' }}>
					<InputConfig
						label="Max Back Pocket Ads Capacity"
						keyData={`${keyData}.optimizedTpvRequests.maxBackPocketAdsCapacity`}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputProps={{ min: 1, max: 100 }}
						defaultValue={4}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						editable={isOptimizedTpvEnabled}
						onChangeCheck={(inputData) => {
							if (inputData > 100) {
								alert(`Max range : 100`);
								return;
							}
							if (inputData < 1) {
								alert(`Min range : 1`);
								return;
							}
							return true;
						}}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};

export default OptimizedTpvConfig;
